// Server-paginated activity feeds for the dashboard "Voir tout" modals. Hand-written axios client (like
// ticketsClient) so the Auth0 bearer interceptor applies on deployed and we avoid a swagger regen.
import axios from "axios";
import type { LogEntry } from "../../API/Models";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export interface ActivityPage {
	items: LogEntry[];
	total: number;
	page: number;
	pageSize: number;
}

export const activityFeedClient = {
	/** A page of the WHOLE team's activity journal (all authors), newest first. */
	all: async (page: number, pageSize: number): Promise<ActivityPage> => {
		const r = await axios.get<ActivityPage>(`${apiBase}/api/logs/paged`, {
			params: { page, pageSize, includeDebug: false },
			withCredentials: true
		});
		return r.data;
	},
	/** A page of the CALLER's own activity journal (their audit-log entries), newest first. */
	mine: async (page: number, pageSize: number): Promise<ActivityPage> => {
		const r = await axios.get<ActivityPage>(`${apiBase}/api/account/activity`, {
			params: { page, pageSize },
			withCredentials: true
		});
		return r.data;
	}
};

export default activityFeedClient;
